import React, { Component } from 'react';
import './Message.css';

class Message extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="message">
        <span className="message__author">{this.props.message.userName}</span>
        {/* {this.props.message.message}
        {this.props.message.dateTime} */}
      </div>
    );
  }
}
export default Message;



// WEBPACK FOOTER //
// ./src/components/messaging/conversation/message/Message.js